var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPteActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.36133V20H0.25V0H11.1387L16.5 5.36133ZM11.5 5H14.3613L11.5 2.13867V5ZM15.25 6.25H10.25V1.25H1.5V18.75H15.25V6.25ZM2.75 8.75H6.5V12.5H2.75V8.75ZM4 11.25H5.25V10H4V11.25ZM2.75 3.75H6.5V7.5H2.75V3.75ZM4 6.25H5.25V5H4V6.25ZM7.75 10H14V11.25H7.75V10ZM2.75 13.75H6.5V17.5H2.75V13.75ZM4 16.25H5.25V15H4V16.25ZM7.75 15H14V16.25H7.75V15Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPteActiveIcon);
export default __webpack_public_path__ + "static/media/PTEActiveIcon.36a95a90bd35ecc457a2bc3076efbc6f.svg";
export { ForwardRef as ReactComponent };